import React, { useRef, useState } from "react";
import IconButton from "../IconButton";
import Popover from "@material-ui/core/Popover";
import { isFunction } from "lodash";

export interface ButtonDropdownProps {
	className?: string;
	menuClassName?: string;
	disabled?: boolean;
	children: (buttonDropDownHelpers: ButtonDropdownChildredProps) => React.ReactNode;
}

export interface ButtonDropdownChildredProps {
	handleClose: () => void;
}

const ButtonDropdown: React.FC<ButtonDropdownProps> = ({ className, menuClassName, children, disabled, ...props }) => {
	const [showMenu, setShowMenu] = useState(false);
	const dotsMenuRef = useRef<HTMLButtonElement>(null);

	const handleClose = () => {
		//Because our widget needs time to handle the event and stop the widget from closing
		setTimeout(() => {
			setShowMenu(false);
		}, 250);
	};

	return (
		<>
			<IconButton
				ref={dotsMenuRef}
				classes={className}
				ariaLabel="Manage Order"
				icon="ellipsis-h"
				onClick={() => {
					setShowMenu(true);
				}}
			></IconButton>
			<Popover
				id={"menu-popover"}
				className={menuClassName ?? "menu-popover"}
				open={showMenu}
				anchorEl={dotsMenuRef.current}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
				elevation={undefined}
			>
				<div className="padded">{isFunction(children) ? children({ handleClose }) : children}</div>
			</Popover>
		</>
	);
};

export default ButtonDropdown;
